// import AOS from 'aos';

// AOS.init({
//     once: true,
// });

const alerts = document.querySelector('[data-sitewide-alert]');
const observer = new MutationObserver(() => {
    if (document.contains(alerts)) {
        alerts.classList.add('is-loaded');
        observer.disconnect();
    }
});

observer.observe(document, {
    attributes: false, childList: true, characterData: false, subtree: true,
});
